import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Header } from "../components/Header";
import { LessonSidebar } from "../components/LessonSidebar";
import { LessonContent } from "../components/LessonContent";
import { UnlockModal } from "../components/UnlockModal";
import "./Index.css";

const Index = () => {
  const { module: routeModule, lessonId: routeLessonId } = useParams();
  const location = useLocation();
  const [unlockModalOpen, setUnlockModalOpen] = useState(false);
  const [selectedLockedLesson, setSelectedLockedLesson] = useState(null);
  const [selectedModuleNumber, setSelectedModuleNumber] = useState(null);

  const isContacts = location.pathname === "/contacts";
  const resolvedModule = routeModule || (isContacts ? "contacts" : undefined);
  const resolvedLessonId = routeLessonId;

  const handleLessonSelect = (lessonId, locked, moduleNumber) => {
    if (locked) {
      setSelectedLockedLesson(lessonId);
      setSelectedModuleNumber(moduleNumber);
      setUnlockModalOpen(true);
    }
  };

  // Обработка события открытия модального окна из навигации
  useEffect(() => {
    const handleOpenUnlockModal = (event) => {
      const { lessonId, moduleNumber } = event.detail;
      setSelectedLockedLesson(lessonId);
      setSelectedModuleNumber(moduleNumber);
      setUnlockModalOpen(true);
    };

    window.addEventListener('openUnlockModal', handleOpenUnlockModal);
    return () => {
      window.removeEventListener('openUnlockModal', handleOpenUnlockModal);
    };
  }, []);

  return (
    <div className="page-container dark">
      <Header />
      
      <div className="page-content">
        <LessonSidebar
          onLessonSelect={handleLessonSelect}
        />
        
        <LessonContent module={resolvedModule} lessonId={resolvedLessonId} />
      </div>

      <UnlockModal
        isOpen={unlockModalOpen}
        onClose={() => setUnlockModalOpen(false)}
        lessonTitle={selectedLockedLesson ? `Lesson ${selectedLockedLesson}` : "Premium Content"}
        moduleNumber={selectedModuleNumber}
      />
    </div>
  );
};

export default Index;

